import { Routes, Route, Link } from 'react-router-dom';
import InventoryList from '../components/InventoryList';
import AddInventory from '../components/AddInventory';
import EditInventory from '../components/EditInventory';
import InventoryDetails from '../components/InventoryDetails';

function InventoryPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-100 to-blue-50 font-sans">
      <header className="sticky top-0 z-50 bg-white shadow-lg border-b border-blue-100">
        <nav className="container mx-auto flex items-center justify-between py-4 px-6">
          <div className="flex items-center gap-3">
            <span className="text-2xl font-extrabold text-blue-700 tracking-tight">UNITEE INVENTORY</span>
          </div>
          <div className="flex gap-6">
            <Link to="/inventory" className="text-blue-700 font-semibold hover:text-blue-900 transition">Inventory List</Link>
            <Link to="/inventory/add" className="text-blue-700 font-semibold hover:text-blue-900 transition">Add Item</Link>
          </div>
        </nav>
      </header>
      <main className="container mx-auto py-10 px-4">
         <Routes>
          <Route index element={<InventoryList />} />
          <Route path="add" element={<AddInventory />} />
          <Route path="edit/:id" element={<EditInventory />} />
          <Route path="details/:id" element={<InventoryDetails />} />
        </Routes>
      </main>
    </div>
  );
}

export default InventoryPage;